module.exports = __webpack_public_path__ + "00b16a3fe3db7f52d668810829659d78.ttf";


/*****************
 ** WEBPACK FOOTER
 ** ./src/font/OpenSans-Light.ttf
 ** module id = 906
 ** module chunks = 9
 **/